import type { ISEOProps } from "../types/core";

export const ComplianceStatementPageSEO: ISEOProps = {
  title: "Compliance Statement - Sugar Cribs",
  description:
    "Read Sugar Cribs compliance statement and learn about our commitment to legal and regulatory compliance.",
};
